import { apiClient } from "./apiClient";

// ============== VPN USERS ==============

export async function getVpnUsers(accessToken, { limit = 20, offset = 0, search } = {}) {
  const params = new URLSearchParams({ limit, offset });
  if (search) params.append("search", search);
  const res = await apiClient.get(`/vpn/users?${params}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data; 
}

export async function getVpnUser(accessToken, vpnUserId) {
  const res = await apiClient.get(`/vpn/users/${vpnUserId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

export async function createVpnUser(accessToken, payload) {
  const res = await apiClient.post("/vpn/users", payload, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

export async function updateVpnUser(accessToken, vpnUserId, payload) {
  const res = await apiClient.patch(`/vpn/users/${vpnUserId}`, payload, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

export async function deleteVpnUser(accessToken, vpnUserId) {
  const res = await apiClient.delete(`/vpn/users/${vpnUserId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// ============== VPN ACCESS LOGS ==============

export async function getVpnUserAccessLogs(accessToken, vpnUserId, { search, limit = 50 } = {}) {
  const params = new URLSearchParams({ limit });
  if (search) params.append("search", search);
  const res = await apiClient.get(`/vpn/users/${vpnUserId}/access-logs?${params}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// ============== VPN SESSIONS ==============

export async function getVpnSessions(accessToken, { is_active, vpn_user_id, search, limit = 50, offset = 0 } = {}) {
  const params = new URLSearchParams({ limit, offset });
  if (is_active !== undefined) params.append("is_active", is_active);
  if (vpn_user_id) params.append("vpn_user_id", vpn_user_id);
  if (search) params.append("search", search);
  const res = await apiClient.get(`/vpn/sessions?${params}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}